import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import {
  Table,
  Button,
  Space,
  Collapse,
  message,
  Row,
  Col,
  Typography,
  Menu,
  Dropdown,
  Spin,
  DatePicker,
  InputNumber,
  Input,
  TableProps,
  InputRef,
} from "antd";
import styles from "./Sample.module.css";
import { useHistory } from "react-router-dom";
import { initToothSample, ToothSample } from "../../models";
import { apiUrl, loginInfo } from "../../config";
import {
  initSampleQueryModel,
  SampleQueryModel,
} from "../../models/SampleQueryModel";

import { SchoolPersonAdd } from "./dialog/SchoolPersonAdd";
import { SchoolPersonEdit } from "./dialog/SchoolPersonEdit";
import { SchoolFillin } from "./dialog/SchoolFillin";
import { Sampling } from "./dialog/Sampling";
import { CAT } from "./dialog/CAT";
import { HospitalFillin } from "./dialog/HospitalFillin";
import { SchoolSampleAdd } from "./dialog/SchoolSampleAdd";
import { HospitalSampleAdd } from "./dialog/HospitalSampleAdd";
import { SchoolSampleEdit } from "./dialog/SchoolSampleEdit";
import { HospitalSampleEdit } from "./dialog/HospitalSampleEdit";

import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  FilterOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  buildReport,
  createTable,
  deleteTable,
  getAllSamples,
  updateTable,
} from "../../api/Api";
//import { BatchDelConfirm } from "../../components/sample/BatchDelConfirm";
import { ColumnType, FilterConfirmProps } from "antd/es/table/interface";
import { DatePickerProps, RangePickerProps } from "antd/es/date-picker";
import { ColumnSelect } from "./dialog/ColumnSelect";

type DataIndex = keyof ToothSample;
export const Sample: React.FC = () => {
  const [addPersonVisible, setAddPersonVisible] = useState(false);
  const [editPersonVisible, setEditPersonVisible] = useState(false);
  const [schoolFillinVisible, setSchoolFillinVisible] = useState(false);
  const [samplingVisible, setSamplingVisible] = useState(false);
  const [CATVisible, setCATVisible] = useState(false);

  const [columnSelectVisible, setColumnSelectVisible] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState<string[]>([
    "id",
    "status",
    "cat",
    "result",
    "name",
    "checkName",
    "checkDate",
  ]);

  const [hospitalFillinVisible, setHospitalFillinVisible] = useState(false);
  const [schoolSampleAddVisible, setSchoolSampleAddVisible] = useState(false);
  const [hospitalSampleAddVisible, setHospitalSampleAddVisible] =
    useState(false);
  const [schoolSampleEditVisible, setSchoolSampleEditVisible] = useState(false);
  const [hospitalSampleEditVisible, setHospitalSampleEditVisible] =
    useState(false);
  const [editRecord, setEditRecord] = useState(initToothSample);
  const [treeData, setTreeData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [searchNumberMin, setSearchNumberMin] = useState<number | null>(null);
  const [searchNumberMax, setSearchNumberMax] = useState<number | null>(null);
  const [searchDateMin, setSearchDateMin] = useState<string>(
    dayjs().format("YYYY-MM-DD")
  );
  const [searchDateMax, setSearchDateMax] = useState<string>(
    dayjs().format("YYYY-MM-DD")
  );

  const [selectedRows, setSelectedRows] = useState<ToothSample[]>([]);
  const searchInput = useRef<InputRef>(null);
  const [loading, setLoading] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectionType, setSelectionType] = useState<"checkbox" | "radio">(
    "checkbox"
  );

  const { RangePicker } = DatePicker;
  const history = useHistory();

  useEffect(() => {
    onQueryClick();
  }, []);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnTextSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<ToothSample> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
              close();
            }}
          >
            过滤
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
              close();
            }}
            size="small"
          >
            取消过滤
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <FilterOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    /*onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },*/
    onFilter: (value, record) => {
      console.log(value);
      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase());
    },
  });

  const getColumnDateSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<ToothSample> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <RangePicker
          value={[
            dayjs(searchDateMin, "YYYY-MM-DD"),
            dayjs(searchDateMax, "YYYY-MM-DD"),
          ]}
          onChange={(
            value: DatePickerProps["value"] | RangePickerProps["value"],
            dateString: [string, string] | string
          ) => {
            if (dateString instanceof Array) {
              setSearchDateMin(dateString[0]);
              setSearchDateMax(dateString[1]);
              setSelectedKeys([dateString[0] + dateString[1]]);
            }
          }}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            size="small"
            onClick={() => {
              setSelectedKeys([searchDateMin + searchDateMax]);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
              close();
            }}
          >
            过滤
          </Button>
          <Button
            onClick={() => {
              setSearchDateMax(dayjs().format("YYYY-MM-DD"));
              setSearchDateMin(dayjs().format("YYYY-MM-DD"));
              setSelectedKeys([]);
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
              close();
            }}
            size="small"
          >
            取消过滤
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <FilterOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    /*onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },*/
    onFilter: (value, record) => {
      let min = dayjs(searchDateMin, "YYYY-MM-DD"),
        max = dayjs(searchDateMax, "YYYY-MM-DD"),
        v = dayjs(record[dataIndex] as string, "YYYY-MM-DD HH:mm:ss");
      if (v < min) return false;
      else if (v > max) return false;
      else return true;
    },
  });

  const getColumnNumberSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<ToothSample> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Row>
          <Space>
            <InputNumber
              placeholder={`${dataIndex}最小值`}
              value={searchNumberMin}
              onChange={(v: number | null) => {
                if (v === null) {
                  setSelectedKeys([]);
                } else {
                  setSelectedKeys([v]);
                  setSearchNumberMin(v);
                }
              }}
              style={{ marginBottom: 8, display: "block", width: 100 }}
            />
            <InputNumber
              placeholder={`${dataIndex}最大值`}
              value={searchNumberMax}
              onChange={(v: number | null) => {
                if (v === null) {
                  setSelectedKeys([]);
                } else {
                  setSelectedKeys([v]);
                  setSearchNumberMax(v);
                }
              }}
              style={{ marginBottom: 8, display: "block", width: 100 }}
            />
          </Space>
        </Row>
        <Row>
          <Space>
            <Button
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearchText((selectedKeys as string[])[0]);
                setSearchedColumn(dataIndex);
                close();
              }}
            >
              过滤
            </Button>
            <Button
              onClick={() => {
                setSearchNumberMax(null);
                setSearchNumberMin(null);
                clearFilters && handleReset(clearFilters);
                confirm({ closeDropdown: false });
                setSearchText((selectedKeys as string[])[0]);
                setSearchedColumn(dataIndex);
                close();
              }}
              size="small"
            >
              取消过滤
            </Button>
          </Space>
        </Row>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <FilterOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    onFilter: (value, record) => {
      let v = record[dataIndex];
      if (searchNumberMin !== null) {
        if ((v as number) < searchNumberMin) return false;
      }
      if (searchNumberMax !== null) {
        if ((v as number) > searchNumberMax) return false;
      }
      return true;
    },
  });

  const remove = async () => {
    setLoading(true);
    let _treeData = treeData;
    for (let i = 0; i < selectedRowKeys.length; i++) {
      await deleteTable("toothsample", parseInt(selectedRowKeys[i].toString()));
      let index = _treeData.findIndex((tr) => tr.key === selectedRowKeys[i]);
      _treeData.splice(index, 1);
    }
    message.info(`共删除了${selectedRowKeys.length}条记录!`);    
    setTotal(_treeData.length);
    setLoading(false);

    setSelectedRows([]);
  };

  const add = async (sample: ToothSample) => {
    let data = await createTable("toothsample", sample);
    if (typeof data === "undefined") {
      history.push("/");
    }
    let _treeData = [{ ...data, key: data.id }, ...treeData];
    setTreeData(_treeData);
    setTotal(total + 1);
  };
  const update = async (sample: ToothSample) => {
    setEditRecord(sample);
    await updateTable("toothsample", sample);
    let _treeData = [...treeData];
    let index = _treeData.findIndex((t) => t.id === sample.id);
    _treeData.splice(index, 1, { ...sample, key: sample.id });
    setTreeData(_treeData);

    setEditRecord(sample);
    for(let i = 0;i < selectedRows.length;i ++){
      if(selectedRows[i].key === sample.key){
        selectedRows[i] = sample;
      }
    }
  };

  const buildColumns = () => {
    let list: any[] = [];

    if (selectedColumn.includes("id"))
      list.push({
        title: "编号",
        dataIndex: "id",
        key: "id",
        width: 100,
        sorter: (a, b) => a.id - b.id,
      });

    if (selectedColumn.includes("status"))
      list.push({
        title: "处理状态",
        dataIndex: "status",
        key: "status",
        width: 100,
        render: (text: any, record: ToothSample) => {
          if (record.status === "检测") {
            return <span>已完成</span>;
          } else {
            return <span>待处理</span>;
          }
        },
        filters: [
          {
            text: "已完成",
            value: "1",
          },
          {
            text: "待处理",
            value: "0",
          },
        ],
        onFilter: (value: any, record) => {
          if (value === "1") return record.status === "检测";
          else if (value === "0") return record.status !== "检测";
          else return true;
        },
      });

    if (selectedColumn.includes("type"))
      list.push({
        title: "受检人类别",
        dataIndex: "type",
        key: "type",
        width: 100,
        render: (text: any, record: ToothSample) => {
          if (record.type === 0) {
            return <span>学校检测</span>;
          } else {
            return <span>医院检测</span>;
          }
        },
        filters: [
          {
            text: "学校检测",
            value: "0",
          },
          {
            text: "医院检测",
            value: "1",
          },
        ],
        onFilter: (value: any, record) => {
          if (value === "0") return record.type === 0;
          else if (value === "1") return record.type !== 0;
          else return true;
        },
      });

    if (selectedColumn.includes("name"))
      list.push({
        title: "姓名",
        dataIndex: "name",
        key: "name",
        width: 100,
        ...getColumnTextSearchProps("name"),
      });

    if (selectedColumn.includes("cat"))
      list.push({
        title: "CAT值",
        dataIndex: "cat",
        key: "CAT",
        width: 80,
        render: (text: any, record: ToothSample) => {
          if (record.cat === -1) {
            return <span></span>;
          } else {
            return <span>{record.cat}</span>;
          }
        },
        filters: [
          {
            text: "未设置",
            value: -1,
          },
          {
            text: "0",
            value: 0,
          },
          {
            text: "0.5",
            value: 0.5,
          },
          {
            text: "1.0",
            value: 1.0,
          },
          {
            text: "1.5",
            value: 1.5,
          },
          {
            text: "2.0",
            value: 2.0,
          },
          {
            text: "2.5",
            value: 2.5,
          },
          {
            text: "3.0",
            value: 3.0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.cat;
        },
      });

    if (selectedColumn.includes("result"))
      list.push({
        title: "评估结果",
        dataIndex: "result",
        key: "result",
        width: 100,
        filters: [
          {
            text: "低风险",
            value: "低风险",
          },
          {
            text: "中风险",
            value: "中风险",
          },
          {
            text: "高风险",
            value: "高风险",
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.ResultStr;
        },
        sorter: (a, b) => a.key - b.key,
      });

    if (selectedColumn.includes("code"))
      list.push({
        title: "受检人编号",
        dataIndex: "code",
        key: "code",
        width: 150,
        ...getColumnTextSearchProps("code"),
      });

    if (selectedColumn.includes("hospitalName"))
      list.push({
        title: "医院",
        dataIndex: "hospitalName",
        key: "hospitalName",
        width: 150,
        ...getColumnTextSearchProps("hospitalName"),
      });

    if (selectedColumn.includes("schoolName"))
      list.push({
        title: "学校",
        dataIndex: "schoolName",
        key: "schoolName",
        width: 150,
        ...getColumnTextSearchProps("schoolName"),
      });

    if (selectedColumn.includes("gradeName"))
      list.push({
        title: "年级",
        dataIndex: "gradeName",
        key: "gradeName",
        width: 100,
        ...getColumnTextSearchProps("gradeName"),
      });

    if (selectedColumn.includes("className"))
      list.push({
        title: "班级",
        dataIndex: "className",
        key: "className",
        width: 100,
        ...getColumnTextSearchProps("className"),
      });

    if (selectedColumn.includes("age"))
      list.push({
        title: "年龄",
        dataIndex: "age",
        key: "age",
        width: 120,
        ...getColumnNumberSearchProps("age"),
        render: (text: any, record: ToothSample) => {
          if (record.ageMonth <= 0) {
            return <span>{record.age}岁</span>;
          } else {
            return (
              <span>
                {record.age}岁{record.ageMonth}月
              </span>
            );
          }
        },
      });

    if (selectedColumn.includes("sex"))
      list.push({
        title: "性别",
        dataIndex: "sex",
        key: "sex",
        width: 80,
        filters: [
          {
            text: "男",
            value: "男",
          },
          {
            text: "女",
            value: "女",
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.sex;
        },
      });

    if (selectedColumn.includes("phoneNo"))
      list.push({
        title: "电话号码",
        dataIndex: "phoneNo",
        key: "phoneNo",
        width: 100,
        ...getColumnTextSearchProps("phoneNo"),
      });

    if (selectedColumn.includes("initName"))
      list.push({
        title: "创建人",
        dataIndex: "initName",
        key: "initName",
        width: 100,
      });

    if (selectedColumn.includes("initDate"))
      list.push({
        title: "创建时间",
        dataIndex: "initDate",
        key: "initDate",
        width: 180,
        ...getColumnDateSearchProps("initDate"),
      });

    if (selectedColumn.includes("fillinName"))
      list.push({
        title: "填报人",
        dataIndex: "fillinName",
        key: "fillinName",
        width: 100,
        ...getColumnTextSearchProps("fillinName"),
      });

    if (selectedColumn.includes("fillinDate"))
      list.push({
        title: "填报时间",
        dataIndex: "fillinDate",
        key: "fillinDate",
        width: 180,
        ...getColumnDateSearchProps("fillinDate"),
      });

    if (selectedColumn.includes("samplingName"))
      list.push({
        title: "临床检查医生",
        dataIndex: "samplingName",
        key: "samplingName",
        width: 180,
        ...getColumnTextSearchProps("samplingName"),
      });

    if (selectedColumn.includes("samplingDate"))
      list.push({
        title: "临床检查时间",
        dataIndex: "samplingDate",
        key: "samplingDate",
        width: 180,
        ...getColumnDateSearchProps("samplingDate"),
      });

    if (selectedColumn.includes("checkName"))
      list.push({
        title: "检测操作人",
        dataIndex: "checkName",
        key: "checkName",
        width: 100,
        ...getColumnTextSearchProps("checkName"),
      });

    if (selectedColumn.includes("checkDate"))
      list.push({
        title: "检测时间",
        dataIndex: "checkDate",
        key: "checkDate",
        width: 180,
        ...getColumnDateSearchProps("checkDate"),
      });

    if (selectedColumn.includes("sender"))
      list.push({
        title: "送检者",
        dataIndex: "sender",
        key: "sender",
        width: 100,
        ...getColumnTextSearchProps("sender"),
      });
      if (selectedColumn.includes("checker"))
      list.push({
        title: "检测医生",
        dataIndex: "checker",
        key: "checker",
        width: 100,
        ...getColumnTextSearchProps("checker"),
      });
    if (selectedColumn.includes("a1"))
      list.push({
        title: "A1",
        dataIndex: "a1",
        key: "a1",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.a1;
        },
      });
    if (selectedColumn.includes("a2"))
      list.push({
        title: "A2",
        dataIndex: "a2",
        key: "a2",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.a2;
        },
      });

    if (selectedColumn.includes("a3"))
      list.push({
        title: "A3",
        dataIndex: "a3",
        key: "a3",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.a3;
        },
      });
    if (selectedColumn.includes("a4"))
      list.push({
        title: "A4",
        dataIndex: "a4",
        key: "a4",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.a4;
        },
      });

    if (selectedColumn.includes("b1"))
      list.push({
        title: "B1",
        dataIndex: "b1",
        key: "b1",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.b1;
        },
      });
    if (selectedColumn.includes("b2"))
      list.push({
        title: "B2",
        dataIndex: "b2",
        key: "b2",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.b2;
        },
      });
    if (selectedColumn.includes("b3"))
      list.push({
        title: "B3",
        dataIndex: "b3",
        key: "b3",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.b3;
        },
      });
    if (selectedColumn.includes("b4"))
      list.push({
        title: "B4",
        dataIndex: "b4",
        key: "b4",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.b4;
        },
      });

    if (selectedColumn.includes("c2"))
      list.push({
        title: "C2",
        dataIndex: "c2",
        key: "c2",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.c2;
        },
      });
    if (selectedColumn.includes("c3"))
      list.push({
        title: "C3",
        dataIndex: "c3",
        key: "c3",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.c3;
        },
      });
    if (selectedColumn.includes("c4"))
      list.push({
        title: "C4",
        dataIndex: "c4",
        key: "c4",
        width: 60,
        filters: [
          {
            text: "是",
            value: 1,
          },
          {
            text: "否",
            value: 0,
          },
        ],
        onFilter: (value: any, record) => {
          return value === record.c4;
        },
      });
    return list;
  };

  const onQueryClick = async () => {
    setLoading(true);
    let data = await getAllSamples(); //大小写转换！！！！
    if (typeof data === "undefined") {
      setLoading(false);
      history.push("/");
    }
    setTotal(data.length);
    let _items: any[] = [];
    data.forEach((t) => _items.push({ ...t, key: t.id }));
    setTreeData(_items);

    setLoading(false);
  };

  const reportPrint = async () => {
    let ids: string = "";
    for (let i = 0; i < selectedRows.length; i++) {
      if (selectedRows[i].status === "检测") ids += selectedRows[i].id + ",";
      else
        message.warning(
          `编号为${selectedRows[i].id}的样本,还没有完成检测,无法查看报告`
        );
    }
    if (ids.length === 0) {
      return;
    }
    ids = ids.substring(0, ids.length - 1);
    if (!loginInfo.user.report) {
      message.info("没有查看报告权限");
      return;
    }
    setLoading(true);
    await buildReport(ids);
    window.open("/report/report" + selectedRowKeys[0] + ".pdf");
    setLoading(false);
  };
  const tableChange: TableProps<ToothSample>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setTotal(extra.currentDataSource.length);
  };

  return (
    <div className={styles["sampleMain"]}>
      {loading && <Spin />}
      {!loading && (
        <>
          <Row>
            <Col span={6}>
              <Typography.Title level={4}>
                受检人列表(共{total}条记录)
              </Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col offset={2}>
              <Space direction="horizontal">
                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (loginInfo.user.add) {
                      setEditRecord({
                        ...initToothSample,
                        hospitalId: loginInfo.user.hospitalId,
                        hospitalName: loginInfo.user.hospitalName,
                      });
                      setHospitalSampleAddVisible(true);
                    } else {
                      message.info("没有增加权限.");
                    }
                  }}
                >
                  增加医院个体受检人
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (loginInfo.user.add) {
                      setEditRecord({
                        ...initToothSample,
                        hospitalId: loginInfo.user.hospitalId,
                        hospitalName: loginInfo.user.hospitalName,
                      });
                      setSchoolSampleAddVisible(true);
                    } else {
                      message.info("没有增加权限.");
                    }
                  }}
                >
                  增加学校集体受检人
                </Button>
                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  icon={<EditOutlined />}
                  onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                      message.info(
                        "请只选择一条记录，再进行操作，当前选择了多条记录."
                      );
                      return;
                    }
                    if (loginInfo.user.check) {
                      setEditRecord(selectedRows[0]);
                      if (selectedRows[0].id === -1) {
                        message.info("请在列表中选择一条记录.");
                        return;
                      }
                      setCATVisible(true);
                    } else {
                      message.info("没有操作权限.");
                    }
                  }}
                >
                  CAT检测
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  icon={<PrinterOutlined />}
                  onClick={() => {
                    if (selectedRowKeys.length <= 0) {
                      message.info("请至少选择一条记录，再查看报告.");
                      return;
                    }
                    reportPrint();
                  }}
                >
                  查看报告
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  key="modifysample"
                  onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                      message.info("请只选择一条记录，再进行操作.");
                      return;
                    }
                    if (loginInfo.user.update) {
                      setEditRecord(selectedRows[0]);
                      if (selectedRows[0].type === 0) {
                        setSchoolSampleEditVisible(true);
                      } else {
                        setHospitalSampleEditVisible(true);
                      }
                    } else {
                      message.info("没有修改权限.");
                    }
                  }}
                >
                  修改
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  key="deletesample"
                  onClick={() => {
                    if (loginInfo.user.delete) {
                      if (selectedRowKeys.length === 0) {
                        message.info(
                          "请在左边列表至少选择一条记录,再进行删除."
                        );
                      } else {
                        remove();
                      }
                    } else {
                      message.info("没有删除权限.");
                    }
                  }}
                >
                  删除
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  key="addsample"
                  onClick={() => {
                    if (loginInfo.user.add) {
                      setEditRecord(initToothSample);
                      setAddPersonVisible(true);
                    } else {
                      message.info("没有增加受检人权限.");
                    }
                  }}
                >
                  增加校园受检人
                </Button>
                <Button
                  size="small"
                  ghost
                  shape="round"
                  type="primary"
                  key="editsample"
                  onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                      message.info("请只选择一条记录，再进行操作.");
                      return;
                    }
                    if (loginInfo.user.update) {
                      setEditRecord(selectedRows[0]);
                      if (selectedRows[0].id === -1) {
                        message.info("请在列表中选择一条记录.");
                        return;
                      }
                      setEditPersonVisible(true);
                    } else {
                      message.info("没有修改受检人权限.");
                    }
                  }}
                >
                  修改校园受检人
                </Button>

                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  key="sampling"
                  onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                      message.info("请只选择一条记录，再进行操作.");
                      return;
                    }
                    if (loginInfo.user.update) {
                      setEditRecord(selectedRows[0]);
                      if (selectedRows[0].id === -1) {
                        message.info("请在列表中选择一条记录.");
                        return;
                      }
                      setSamplingVisible(true);
                    } else {
                      message.info("没有操作权限.");
                    }
                  }}
                >
                  采样和临床检查
                </Button>
                <Button
                  size="small"
                  ghost
                  type="primary"
                  shape="round"
                  onClick={() => setColumnSelectVisible(true)}
                >
                  列选择
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                className={styles["table"]}
                bordered
                columns={buildColumns()}
                scroll={{ x: 1024, y: "calc(100vh - 300px)" }}
                dataSource={treeData}
                rowSelection={{
                  type: "checkbox",
                  onChange: (
                    _selectedRowKeys: React.Key[],
                    _selectedRows: ToothSample[]
                  ) => {
                    setSelectedRows(_selectedRows);
                    setSelectedRowKeys(_selectedRowKeys);
                    if (selectedRows.length === 1)
                      setEditRecord(selectedRows[0]);
                  },
                }}
                onChange={tableChange}
              />
            </Col>
          </Row>
          <SchoolPersonAdd
            visible={addPersonVisible}
            setInvisible={() => setAddPersonVisible(false)}
            add={add}
            editRecord={editRecord}
          />

          <SchoolPersonEdit
            visible={editPersonVisible}
            setInvisible={() => setEditPersonVisible(false)}
            update={update}
            editRecord={editRecord}
          />

          <SchoolFillin
            visible={schoolFillinVisible}
            setInvisible={() => setSchoolFillinVisible(false)}
            update={update}
            editRecord={editRecord}
          />

          <Sampling
            visible={samplingVisible}
            setInvisible={() => setSamplingVisible(false)}
            update={update}
            editRecord={editRecord}
          />

          <CAT
            visible={CATVisible}
            setInvisible={() => setCATVisible(false)}
            update={update}
            editRecord={editRecord}
          />

          <HospitalFillin
            visible={hospitalFillinVisible}
            setInvisible={() => setHospitalFillinVisible(false)}
            add={add}
          />

          <SchoolSampleAdd
            visible={schoolSampleAddVisible}
            setInvisible={() => setSchoolSampleAddVisible(false)}
            add={add}
            editRecord={editRecord}
          />

          <HospitalSampleAdd
            visible={hospitalSampleAddVisible}
            setInvisible={() => setHospitalSampleAddVisible(false)}
            add={add}
            editRecord={editRecord}
          />

          <SchoolSampleEdit
            visible={schoolSampleEditVisible}
            setInvisible={() => setSchoolSampleEditVisible(false)}
            update={update}
            editRecord={editRecord}
          />

          <HospitalSampleEdit
            visible={hospitalSampleEditVisible}
            setInvisible={() => setHospitalSampleEditVisible(false)}
            update={update}
            editRecord={editRecord}
          />
          <ColumnSelect
            visible={columnSelectVisible}
            setInvisible={() => setColumnSelectVisible(false)}
            update={setSelectedColumn}
            checked={selectedColumn}
          />
        </>
      )}
    </div>
  );
};
